import Skeleton from '../../skeleton'

const AchievementCardSkeleton = () => {
  return (
    <div className="flex flex-col gap-12 sm:gap-16">
      <div className="border-1 rounded-[8px] border-gray-200 bg-white p-16">
        <div className="flex flex-row gap-20">
          <div className="flex flex-col items-center">
            <Skeleton.Circle h={80} w={80} />
            <Skeleton.Rectangular h={22} w={80} className="mt-[4px]" />
          </div>
          <div className="flex w-full flex-col">
            <Skeleton.Rectangular h={26} w={160} className="mb-[4px]" />
            <Skeleton.Rectangular h={26} w={180} className="mb-[4px]" />
            <div className="flex flex-grow flex-row items-end gap-8">
              <Skeleton.Rectangular h={20} w={'100%'} />
              <Skeleton.Rectangular h={20} w={30} />
            </div>
          </div>
        </div>
      </div>
      <div className="border-1 rounded-[8px] border-gray-200 bg-white p-16">
        <div className="flex flex-row gap-20">
          <div className="flex flex-col items-center">
            <Skeleton.Circle h={80} w={80} />
            <Skeleton.Rectangular h={22} w={80} className="mt-[4px]" />
          </div>
          <div className="flex w-full flex-col">
            <Skeleton.Rectangular h={26} w={160} className="mb-[4px]" />
            <Skeleton.Rectangular h={26} w={180} className="mb-[4px]" />
            <div className="flex flex-grow flex-row items-end gap-8">
              <Skeleton.Rectangular h={20} w={'100%'} />
              <Skeleton.Rectangular h={20} w={30} />
            </div>
          </div>
        </div>
      </div>
      <div className="border-1 rounded-[8px] border-gray-200 bg-white p-16">
        <div className="flex flex-row gap-20">
          <div className="flex flex-col items-center">
            <Skeleton.Circle h={80} w={80} />
            <Skeleton.Rectangular h={22} w={80} className="mt-[4px]" />
          </div>
          <div className="flex w-full flex-col">
            <Skeleton.Rectangular h={26} w={160} className="mb-[4px]" />
            <Skeleton.Rectangular h={26} w={180} className="mb-[4px]" />
            <div className="flex flex-grow flex-row items-end gap-8">
              <Skeleton.Rectangular h={20} w={'100%'} />
              <Skeleton.Rectangular h={20} w={30} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AchievementCardSkeleton
